function StatsCard({ title, value, percent, icon, large }) {
  return (
    <div className={`stats-card ${large && "large"}`}>
      <div className={`img-container ${large && "large"}`}>
        {icon}
      </div>
      <div className="card-content">
        <h3 className={`card-title ${large && "large"}`}>{title}</h3>
        <div className="card-footer">
          <p className={`card-value ${large && "large"}`}>{value}</p>
          {percent && (<small className="card-additional-detail">{percent}</small>)}
        </div>
      </div>
    </div>
  )
};

export default StatsCard;